import type { FC } from 'react'
import type { CellProps } from '../../../interfaces'

type Props = CellProps

const DefaultCell: FC<Props> = ({ title }) => {
  const renderDiv = () => {
    const titleSplit = title.split(',')
    return titleSplit.length >= 2 ? (
      <div className='custom-cell'>
        {titleSplit.map((item, index) => {
          return (
            <div key={`${item}-${index}`} className='custom-cell__item'>
              {item}
            </div>
          )
        })}
      </div>
    ) : (
      <div className='custom-cell'>{title}</div>
    )
  }
  return renderDiv()
}

export default DefaultCell
